import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import { UnitTransferDocumentTypeEnumType } from '__generated__/graphql';
import { FC, useRef, useState } from 'react';

import Button from 'primitives/Button';
import { Dialog, DialogActions, DialogPanel, DialogTitle } from 'primitives/Dialog';

import { FormInput, FormPanel } from 'components/FormPanel';

const UPLOAD_UNIT_TRANSFER_DOCUMENT_MUTATION = gql(`
  mutation UploadUnitTransferDocument($requestId: ID!, $type: UnitTransferDocumentTypeEnumType!, $file: Upload!) {
    uploadUnitTransferDocument(requestId: $requestId, type: $type, file: $file) {
      id
      status
      url
    }
  }
`);

const UploadUnitTransferDocumentDialogButton: FC<{
  requestId: string;
  type: UnitTransferDocumentTypeEnumType;
  label: string;
}> = ({ requestId, type, label }) => {
  const [showDialog, toggleDialog] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const [uploadDocument, { loading, error }] = useMutation(UPLOAD_UNIT_TRANSFER_DOCUMENT_MUTATION, {
    refetchQueries: ['getUnitTransferRequestDocuments'],
  });

  return (
    <>
      <Button variant="secondary" onClick={() => toggleDialog(true)}>
        Upload
      </Button>
      <Dialog open={showDialog} onClose={() => toggleDialog(false)}>
        <DialogPanel>
          <DialogTitle>Upload {label}</DialogTitle>
          <FormPanel
            loading={loading}
            error={error}
            onCancel={() => toggleDialog(false)}
            onSubmit={data =>
              uploadDocument({ variables: { requestId, type, file: data.file } }).then(() =>
                toggleDialog(false)
              )
            }
            buttonRef={buttonRef}
          >
            <FormInput type="upload" fieldName="file" label="File" defaultValue="" onlyAcceptsPDF />
          </FormPanel>
          <DialogActions>
            <Button
              variant="secondary"
              onClick={() => {
                // @ts-ignore
                buttonRef.current?.cancel();
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                // @ts-ignore
                buttonRef.current?.submit();
              }}
              loading={loading}
            >
              Submit
            </Button>
          </DialogActions>
        </DialogPanel>
      </Dialog>
    </>
  );
};

export default UploadUnitTransferDocumentDialogButton;
